import { axiosPost } from 'shared/api/axios'
import { apiUrls } from 'consts'
import displayGenError from 'shared/utils/displayGenError'
import axios, { AxiosError, AxiosRequestConfig } from 'axios'
import Store from 'redux/Store'
import { setMessage } from 'redux/actions'

interface submitFormProps {
  id: string | undefined
  setShowOverlay: Function
  setSyncCount: Function
}

const synchronizeEntity = async (props: submitFormProps) => {
  props.setShowOverlay(true)

  let response: any = false

  const formData = { entity_id: props.id }

  const catchFunc = (err: AxiosError) => {
    const message = err?.response?.data?.message ?? 'An error has occurred'
    displayGenError({ setShowOverlay: props.setShowOverlay, message: message })
  }

  response = await axiosPost(
    apiUrls.entities + '/' + apiUrls.actionSynchronize,
    formData,
    catchFunc,
  )

  if (response?.status === 200) {
    Store.dispatch(setMessage('Entity successfully added to the Sync Queue.', 'success', 'instant'))
    props.setSyncCount((prevValue) => prevValue + 1)
  }
  props.setShowOverlay(false)
}

export default synchronizeEntity
